import React, { FC, ReactNode, useState } from 'react';
import { ProcurementContext } from './context';
import { ENUM_PROCUREMENT_STATUS, ProcurementType } from 'models/procurement.model';

export const DefaultProcurement: ProcurementType = {
  code: '',
  cost_of_received_items: '',
  expected_cost: '',
  cokitched_id: '',
  created_at: '',
  updated_at: '',
  id: '',
  items: [],
  note: '',
  title: '',
  status: ENUM_PROCUREMENT_STATUS.PENDING
};
const ProcurementProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [procurementToUpdate, setProcurementToUpdate] =
    useState<ProcurementType>(DefaultProcurement);
  return (
    <ProcurementContext.Provider
      value={{
        procurementToUpdate,
        setProcurementToUpdate
      }}>
      {children}
    </ProcurementContext.Provider>
  );
};

export default ProcurementProvider;
